<template>
  <div class="container">
    <h1>翻訳テーブルの確認</h1>
    <p>
      CKANからOrionへデータ連携する際に利用する日本語の変換テーブルに登録されているデータを以下よりご確認ください。
    </p>
    <p class="errorMsg" v-if="errorFlag">
      読み込みに失敗しました。<br />
      時間を置いて再度ご確認ください。
    </p>
    <div class="alert">
      <v-alert
        v-model="alert"
        border="start"
        variant="tonal"
        closable
        close-label=""
        color="red-accent-4"
        title="一致するアイテム無し"
      >
        検索した語句に一致するアイテムが1つもありませんでした。
        検索する語句や検索方法を見直すか、翻訳テーブルにアイテムを追加ください。
      </v-alert>
    </div>
    <div class="nonTable" v-if="this.selected_data.length != 0">
      <div class="fillterSpase">
        <v-card class="card">
          <div class="cardTitle" @click="this.show = !this.show">
            <v-icon icon="mdi-magnify" class="filterIcon"></v-icon>
            <p class="filterTitle">ワード検索</p>
            <v-icon
              icon="mdi-chevron-down"
              class="arrowIcon"
              v-show="!this.show"
            ></v-icon>
            <v-icon
              icon="mdi-chevron-up"
              class="arrowIcon"
              v-show="this.show"
            ></v-icon>
          </div>
          <v-expand-transition class="expand">
            <div v-show="show">
              <v-divider></v-divider>
              <div class="fillter">
                <v-text-field
                  v-model="check_item"
                  label="検索語句"
                  class="searchText"
                ></v-text-field>
                <v-btn class="btn1 bg-blue-lighten-1" @click="search()"
                  >検索</v-btn
                >
                <v-btn class="btn2 bg-grey-lighten-3" @click="clear()"
                  >クリア</v-btn
                >
                <p class="explane">
                  （日本語で検索したいカラム名を入力してください。,（カンマ）で繋げて複数句を検索することも可能です。）
                </p>
              </div>
            </div>
          </v-expand-transition>
        </v-card>
      </div>
    </div>
    <div class="table">
      <loading
        :active="true"
        :is-full-page="false"
        :height="50"
        :opacity="0"
        v-if="this.selected_data.length == 0"
      />
      <div class="nowLoading" v-if="this.selected_data.length == 0">
        <p>Now Loading...</p>
      </div>
      <div class="item" v-if="this.selected_data.length != 0">
        <v-table density="default">
          <thead>
            <tr>
              <th class="text-left font-weight-bold">日本語</th>
              <th class="text-left font-weight-bold">英語</th>
              <th class="text-left font-weight-bold" v-if="authority">
                アイテムの削除
              </th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="item in selected_data" :key="item.ja">
              <td class="font-weight-medium">
                {{ item.ja }}
              </td>
              <td class="font-weight-medium">
                {{ item.en }}
              </td>
              <td class="font-weight-medium" v-if="authority">
                <v-icon
                  icon="mdi-delete-outline"
                  @click="deleteItem(item.ja)"
                  class="deleteIcon"
                ></v-icon>
              </td>
            </tr>
          </tbody>
        </v-table>
        <v-pagination v-model="page" :length="pages"></v-pagination>
      </div>
    </div>
  </div>
</template>

<script>
import axios from "axios";
import Loading from "vue-loading-overlay";
import "vue-loading-overlay/dist/css/index.css";

export default {
  data() {
    return {
      errorFlag: false,
      categorySelected: true,
      show: false,
      showValidate: false,
      pages: 0,
      page: 1,
      perPage: 10,
      items: 0,
      datas: [],
      selected_data: [],
      smc: [],
      check_item: "",
      alert: false,
    };
  },
  watch: {
    page() {
      let tmpArr = [];
      for (let i = 0; i < this.items; i += this.perPage)
        tmpArr.push(this.datas.slice(i, i + this.perPage));
      this.selected_data = tmpArr[this.page - 1];
    },
  },
  methods: {
    clear() {
      this.alert = false;
      this.page = 1;
      this.check_item = "";
      this.datas = [];
      this.selected_data = [];
      this.unregistered = false;
      axios
        .get("https://api.dataplatform-yamanashi.jp/translate-table", {
          headers: { Authorization: "Bearer " + this.token },
          params: {
            check_item: this.check_item,
          },
        })
        .then((response) => {
          this.datas = response.data;
          this.items = this.datas.length;
          this.pages = Math.ceil(this.items / this.perPage);
          let tmpArr = [];
          for (let i = 0; i < this.items; i += this.perPage) {
            tmpArr.push(this.datas.slice(i, i + this.perPage));
          }
          this.selected_data = tmpArr[this.page - 1];
        })
        .catch((error) => {
          console.log(error);
          this.errorFlag = true;
        });
    },
    search() {
      this.alert = false;
      this.page = 1;
      this.datas = [];
      this.selected_data = [];
      axios
        .get("https://api.dataplatform-yamanashi.jp/translate-table", {
          headers: { Authorization: "Bearer " + this.token },
          params: {
            check_item: this.check_item,
          },
        })
        .then((response) => {
          this.datas = response.data;
          this.items = this.datas.length;
          if (this.items === 0) {
            this.clear();
            this.alert = true;
          } else {
            this.pages = Math.ceil(this.items / this.perPage);
            let tmpArr = [];
            for (let i = 0; i < this.items; i += this.perPage) {
              tmpArr.push(this.datas.slice(i, i + this.perPage));
            }
            this.selected_data = tmpArr[this.page - 1];
          }
        })
        .catch((error) => {
          console.log(error);
          this.errorFlag = true;
        });
    },
    deleteItem(item) {
      axios
        .delete("https://api.dataplatform-yamanashi.jp/translate-table", {
          data: { ja: item },
          headers: { Authorization: "Bearer " + this.token },
        })
        .then(() => {
          this.clear();
        })
        .catch((error) => {
          console.log(error);
          this.errorFlag = true;
        });
    },
  },
  mounted() {
    axios
      .get("https://api.dataplatform-yamanashi.jp/translate-table", {
        headers: { Authorization: "Bearer " + this.token },
        params: {
          check_item: "",
        },
      })
      .then((response) => {
        this.datas = response.data;
        this.items = this.datas.length;
        this.pages = Math.ceil(this.items / this.perPage);
        let tmpArr = [];
        for (let i = 0; i < this.items; i += this.perPage) {
          tmpArr.push(this.datas.slice(i, i + this.perPage));
        }
        this.selected_data = tmpArr[this.page - 1];
      })
      .catch((error) => {
        console.log(error);
        this.errorFlag = true;
      });
  },
  computed: {
    token() {
      return this.$store.getters.token;
    },
    authority() {
      return this.$store.getters.authority;
    },
  },
  components: {
    Loading,
  },
};
</script>

<style scoped>
.container {
  width: 100%;
  margin: 36px 5%;
  display: flex;
  flex-direction: column;
  row-gap: 10px;
}

.nowLoading {
  width: 100%;
  height: 200px;
  display: flex;
  justify-content: center;
  align-items: center;
  padding-top: 100px;
}

.item {
  margin-top: 40px;
  width: 90%;
}

.fillterSpase {
  width: 50%;
  margin-bottom: 12px;
}

.validateSpace {
  width: 30%;
  margin-bottom: 12px;
}

.card {
  margin-top: 36px;
  padding: 1vw;
}

.cardTitle {
  display: grid;
  grid-template-columns: 30px auto auto 30px;
  grid-template-rows: auto;
  justify-items: start;
  align-items: center;
  grid-template-areas: "filterIcon filterTitle . arrowIcon";
  font-size: 1.2vw;
  cursor: pointer;
}

.filterTitle {
  grid-area: filterTitle;
  font-size: 1.2vw;
  font-weight: 500;
}

.filterIcon {
  grid-area: filterIcon;
}

.arrowIcon {
  grid-area: arrowIcon;
}
.expand {
  padding: 28px 0;
}

.fillter {
  display: grid;
  padding: 2vw;
  grid-template-columns: 1fr 1fr;
  grid-template-rows: 1fr 0.5fr 0.5fr;
  grid-template-areas:
    "search search"
    "btn1 btn2"
    "explane explane";
  grid-column-gap: 20px;
  grid-row-gap: 1vw;
}

.explane {
  grid-area: explane;
}

.validate {
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  row-gap: 1vw;
}

.error {
  color: #d32f2f;
  background-color: #ffebee;
}

.nonTable {
  display: flex;
  width: 100%;
  align-items: flex-start;
  column-gap: 2vw;
}

.time {
  font-size: 1.6vw;
  font-weight: 500;
}

.table {
  position: relative;
}

.searchText {
  grid-area: search;
}

.btn1 {
  grid-area: btn1;
}

.btn2 {
  grid-area: btn2;
}

.alert {
  width: 80%;
}

.deleteIcon {
  cursor: pointer;
}
</style>
